import { render } from "./RegulatoryManualSelect.vue?vue&type=template&id=bad4a398&scoped=true"
import script from "./RegulatoryManualSelect.vue?vue&type=script&lang=js"
export * from "./RegulatoryManualSelect.vue?vue&type=script&lang=js"

import "./RegulatoryManualSelect.vue?vue&type=style&index=0&id=bad4a398&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad4a398"]])

export default __exports__